<div class="collab-list-item-container user-img-show-indicator" (click)="onClickEvent()">
    <div class="collab-list-item-user-image">
        <user-image
            imageSize="small"
            [hasImage]="false"
            [imagePath]="false"
            [userInitials]="teamGroup.initials"
            [userRegistered]="true">
        </user-image>
    </div>
    <div class="collab-list-item-inner">
        <p class="collab-list-item-collab-name fx-ellipsis body">{{teamGroup.displayName}}</p>
        <p class="collab-list-item-collab-email fx-ellipsis grey caption">{{teamGroup.description}}</p>
    </div>
</div>